<template>
	<div v-if="removed" class="task-card">
		<div class="task-card-top">
			<img
				class="task-card-check"
				src="/images/common/task-checkbox.png"
				alt=""
			/>
			<span id="removed-task-card-span">{{
				systemmessageparts?.task_title
			}}</span>
		</div>
		<div class="removed-task-card-sub-bottom">
			<span>{{ $t('tasks_unavailable') }}</span>
		</div>
	</div>
	<div v-else-if="task" class="task-card pointer" @click="$emit('open')">
		<div
			class="task-card-top"
			:class="{ 'task-card-top-completed': isCompleted }"
		>
			<div
				v-if="!isCompleted"
				id="taskCompleteCheckbox"
				class="task-card-check pointer"
				@click.stop="$emit('complete')"
			></div>
			<div
				v-else
				id="taskUnCompleteCheckbox"
				class="task-card-check pointer"
				@click.stop="$emit('uncomplete')"
			></div>
			<span id="task-card-span">{{ task.title }}</span>
			<img
				id="task-card-arrow"
				class="task-card-arrow"
				src="/images/common/task-list-arrow.png"
				alt="Task List"
			/>
		</div>
		<div
			class="task-card-bottom task-card-bottom-corners"
			:class="{
				'task-card-bottom-nocorners': isUnassigned,
				'task-card-bottom-completed': isCompleted,
			}"
		>
			<div>
				<img src="/images/common/task-card-calendar.png" alt="Task Calendar" />
				<span
					v-if="!isCompleted"
					:class="{ 'task-card-past-due': isPastDue }"
					>{{ $t('tasks_due_date', [dueDateDisplay(task.due)]) }}</span
				>
				<span v-else>
					{{ $t('tasks_completed_date', [dueDateDisplay(task.completed)]) }}
				</span>
			</div>
		</div>
		<div
			v-if="isUnassigned"
			class="task-card-sub-bottom pointer"
			@click.stop="$emit('claim')"
		>
			<span>{{ $t('tasks_action_claim') }}</span>
		</div>
	</div>
</template>

<script>
import { dueDateDisplay, isTaskPastDue } from './utils'

export default {
	name: 'TaskCard',

	props: {
		task: { type: Object, default: null },
		systemmessageparts: { type: Object, default: null },
		removed: { type: Boolean, default: false },
	},

	emits: ['open', 'complete', 'uncomplete', 'claim'],

	computed: {
		isCompleted() {
			return !!this.task?.completed
		},
		isUnassigned() {
			return !this.task?.assigneeuser_id
		},
		isPastDue() {
			return isTaskPastDue(this.task)
		},
	},

	methods: {
		dueDateDisplay,
	},
}
</script>
